function closestAttributeValue($element, attributeName) {
  var $closestElementWithAttribute = $element.closest("[".concat(attributeName, "]"));
  return $closestElementWithAttribute ? $closestElementWithAttribute.getAttribute(attributeName) : null;
}
export { closestAttributeValue };